import { render, staticRenderFns } from "./OtherContent.vue?vue&type=template&id=c6356d6e&scoped=true&"
import script from "./OtherContent.vue?vue&type=script&lang=js&"
export * from "./OtherContent.vue?vue&type=script&lang=js&"
import style0 from "./OtherContent.vue?vue&type=style&index=0&id=c6356d6e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6356d6e",
  null
  
)

export default component.exports